import { Button, Menu, MenuItem, SvgIcon } from "@mui/material";
import ChevronDownIcon from "@untitled-ui/icons-react/build/esm/ChevronDown";
import PropTypes from "prop-types";
import React, { useCallback, type FC } from "react";

import { CheckOutlined } from "@mui/icons-material";
import { usePopover } from "../../hooks";

interface SelectProps {
  label: string;
  // Same as type as the value received above
  onChange?: (value: any) => void;
  options: { label: string; value: unknown }[];
  value: any;
  isLabelFollowSelected?: boolean; // Show the value of the selected option on the Dropdown
  isUnselectAllowed?: boolean;
}

export const Select: FC<SelectProps> = (props) => {
  const {
    label,
    onChange,
    options,
    isLabelFollowSelected,
    isUnselectAllowed,
    value = null,
    ...other
  } = props;
  const popover = usePopover<HTMLButtonElement>();

  const handleSelect = useCallback(
    (value: any): void => {
      // If the value is the same as the current value, then unselect by setting it to null
      onChange?.(value === props.value && isUnselectAllowed ? null : value);
    },
    [onChange, value],
  );

  return (
    <>
      <Button
        color="inherit"
        endIcon={
          <SvgIcon>
            <ChevronDownIcon />
          </SvgIcon>
        }
        onClick={popover.handleOpen}
        ref={popover.anchorRef}
        {...other}
      >
        {isLabelFollowSelected
          ? options.find((opt) => opt.value === value)?.label ?? label
          : label}
      </Button>
      <Menu
        anchorEl={popover.anchorRef.current}
        onClose={popover.handleClose}
        open={popover.open}
        // PaperProps={{ style: { width: 250 } }}
      >
        {options.map((option) => (
          <MenuItem
            key={option.label}
            onClick={(e) => handleSelect(option.value)}
          >
            {option.label}{" "}
            {option.value === value && <CheckOutlined sx={{ ml: 1 }} />}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};

Select.propTypes = {
  label: PropTypes.string.isRequired,
  onChange: PropTypes.func,
  options: PropTypes.array.isRequired,
  value: PropTypes.any,
};
